import React from 'react';
import { TrendingUp, Target, BarChart4 } from 'lucide-react';

const Hero2 = () => {
  const rw="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/rw.svg";
  const lsg="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/ls.svg";
  const lens="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/lens.svg";
  return (
    <div>
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8 text-center">
        <h2 className="text-lg md:text-xl leading-relaxed text-center text-gray-800 font-semibold">
          Our systematic approach focuses on quality investments that stand the test of time.
        </h2>
        
        {/* Three icons in a row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mt-8">
          {/* RW Icon */}
          <div className="flex flex-col items-center p-2 rounded-lg">
            <img src={rw} alt="RW" className="w-24 h-24" />
            <h3 className="text-xl font-semibold mt-4 text-gray-800">RW</h3>
          </div>
          
          {/* 3Lens Icon */}
          <div className="flex flex-col items-center p-2 rounded-lg">
            <img src={lens} alt="3Lens" className="w-24 h-24" />
            <h3 className="text-xl font-semibold mt-4 text-gray-800">3Lens</h3>
          </div>
          
          {/* LSG Icon */}
          <div className="flex flex-col items-center p-2 rounded-lg">
            <img src={lsg} alt="LSG" className="w-24 h-24" />
            <h3 className="text-xl font-semibold mt-4 text-gray-800">LSG</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero2;